export default "__VITE_PUBLIC_ASSET__70a1a097__"